import { useCallback } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import {
  EntitySettingsTabIds,
  validTabIds,
} from '../models/entity-settings-tabs';

export const useEntitySettings = () => {
  // Hooks
  const navigate = useNavigate();
  const { id, name } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  // States
  const activeTabId = searchParams.get('painel') as EntitySettingsTabIds;

  // Methods
  const setActiveTab = useCallback((tabId: EntitySettingsTabIds) => {
    setSearchParams((params) => {
      if (!tabId || !validTabIds.includes(tabId)) {
        params.set('painel', 'visao-geral');
        return params;
      }

      params.set('painel', tabId);
      return params;
    });
  }, []);

  return {
    navigate,
    setActiveTab,
    id,
    name,
    activeTabId,
  };
};
